import React from 'react';
import styled from 'styled-components';

const InputCircle = styled.div`
  border-radius: 50%;
  width: 10px;
  height: 10px;
  background-color: #fff;
  border: 1px solid ${props => props.theme.brandingPrimaryShadeFour};
  padding: 5px;
  margin-right: 15px;
`;
const InputInnerCircle = styled.div`
  border-radius: 50%;
  width: 10px;
  height: 10px;
  background-color: ${props => (props.selected ? props.theme.brandingPrimaryShadeFour : '#fff')};
`;

export default ({ selected }) => (
  <InputCircle>
    <InputInnerCircle selected={selected} />
  </InputCircle>
);
